import React from "react";
import LiveChat from "../components/LiveChat";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

const LiveChatPage = () => {
  return (
    <>
      <BreadcrumbTwo title="Live Chat" />
      <LiveChat />
    </>
  );
};

export default LiveChatPage;